__turbopack_context__.v({
  "clip": "SidebarDisclosure-module__x3W0SW__clip",
  "content": "SidebarDisclosure-module__x3W0SW__content",
  "disclosure": "SidebarDisclosure-module__x3W0SW__disclosure",
});
